import { useAppDispatch } from "store/hooks";
import { fetchUserSettings as fetchUserSettingsAction } from "store/thunks/userThunks";
import {
  setSettings as setSettingsAction,
  updateSettings as updateSettingsAction,
} from "store/slices/userSlice";
import { UserSettingsT } from "../models/models";
const useReduxUser = () => {
  const dispatch = useAppDispatch();

  const fetchUserSettings = async () => {
    return dispatch(fetchUserSettingsAction()).unwrap();
  };

  const setSettings = (settings: UserSettingsT) => {
    dispatch(setSettingsAction(settings));
  };

  const updateSettings = (settings: Partial<UserSettingsT>) => {
    dispatch(updateSettingsAction(settings));
  };

  return { fetchUserSettings, setSettings, updateSettings };
};

export default useReduxUser;
